import React from 'react';
import { ShieldCheckIcon, TimerIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { images } from '../data/landing';
import { useCountdown } from '../contexts/CountdownContext';
export function PriceBlock() {
  const {
    label
  } = useCountdown();
  return <section className="w-full bg-white pb-20 md:pb-28" aria-labelledby="price-title" data-id="element-170" data-mp="27vzydcs1smya">
      <div className="mx-auto max-w-4xl px-5" data-id="element-171" data-mp="27u6uu6cqeiui">
        <div className="grid items-center gap-8 rounded-[36px] bg-cream p-6 ring-1 ring-line md:grid-cols-[1fr_1.1fr] md:p-10" data-id="element-172" data-mp="1k7gsf3wh0m9d">
          <img src={images.cover} alt="Maker Lab project library cover" className="w-full rounded-[28px] shadow-lift" data-id="element-173" data-mp="1g6oie8frydc1" />

          <div className="text-center" data-id="element-174" data-mp="1ty2zg9q4g4gg">
            <h2 id="price-title" className="font-display text-3xl font-bold text-ink" data-id="element-175" data-mp="1p4gzni523v22">Maker Lab™ Project Library</h2>
            <div className="mt-4 flex items-end justify-center gap-3" data-id="element-176" data-mp="11emkuv16fwf6">
              <span className="pb-2 text-2xl font-bold text-inkSoft line-through" data-id="element-177" data-mp="whmh4qrsv5r8">$54.00</span>
              <span className="font-display text-7xl font-bold leading-none text-ink" data-id="element-178" data-mp="1s09qrgnn4fkn">$27.00</span>
            </div>

            <CTAButton fullWidth className="mt-7" size="md" data-id="element-179" data-mp="1wxt3ud8lqmb0">Yes, I want the complete method!</CTAButton>

            <p className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-inkSoft" data-id="element-180" data-mp="21qvykop481ss">
              <ShieldCheckIcon className="h-4 w-4 text-teal" aria-hidden data-id="element-181" data-mp="26ncmbhseke5c" />
              100% Protected purchase & instant digital delivery
            </p>

            <div className="mt-6 rounded-2xl bg-blush px-4 py-3" data-id="element-182" data-mp="1dzyzicif4yyy">
              <p className="flex items-center justify-center gap-2 font-display text-4xl font-bold tabular-nums text-berry" data-id="element-183" data-mp="1e08nxvntey2j">
                <TimerIcon className="h-7 w-7" aria-hidden data-id="element-184" data-mp="1n0opgzkzzv4r" />
                {label}
              </p>
              <p className="mt-1 text-sm font-extrabold text-berry" data-id="element-185" data-mp="2ue8l4yva09m3">Your special discount expires soon</p>
            </div>

            <img src={images.payments} alt="Accepted payments: PayPal, Visa, Mastercard, American Express" className="mx-auto mt-6 h-12 mix-blend-multiply" data-id="element-186" data-mp="2yf2a7vkgfugk" />
          </div>
        </div>
      </div>
    </section>;
}